<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem; margin-bottom: 0!important;">
		<div class="py-2 border-bottom d-flex align-items-center">
			<el-button type="primary" size="mini" icon="el-icon-search">查询</el-button>
			<el-button type="primary" size="mini" @click="openModel('qtxm')" icon="el-icon-plus">添加</el-button>
		</div>
		<div>
			<el-table
				:data="qtxmList"
				style="width: 100%"
				size="mini"
				row-key="id"
				:tree-props="{ children: 'child', hasChildren: 'hasChildren' }"
				@current-change="handleCurrentChange"
			>
				<el-table-column width="80" align="center">
					<template slot="header" slot-scope="scope">
						编号
					</template>
					<template slot-scope="scope">
						{{ scope.row.id }}
					</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">
						项目名称
					</template>
					<template slot-scope="scope">
						{{ scope.row.mc }}
					</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">
						备注
					</template>
					<template slot-scope="scope">
						{{ scope.row.desc }}
					</template>
				</el-table-column>
				<el-table-column align="center">
					<template slot="header" slot-scope="scope">
						负责人
					</template>
					<template slot-scope="scope">
						<el-button type="primary" size="mini" plain>{{ scope.row.fzr.name }}</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center">
					<template slot="header" slot-scope="scope">
						部门
					</template>
					<template slot-scope="scope">
						<el-button type="primary" size="mini" plain>{{ scope.row.bm.name }}</el-button>
					</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">
						项目期限
					</template>
					<template slot-scope="scope">
						{{ scope.row.xmqx }}
					</template>
				</el-table-column>
				<el-table-column align="center" fixed="right" width="80">
					<template slot="header" slot-scope="scope">
						排序编号
					</template>
					<template slot-scope="scope">
						{{ scope.row.id }}
					</template>
				</el-table-column>
				<el-table-column align="center" fixed="right" width="290">
					<template slot="header" slot-scope="scope">
						操作
					</template>
					<template slot-scope="scope">
						<!-- <el-button type="primary" size="mini" @click="openModel('qtxm',scope.row)">查看</el-button> -->
						<el-button type="primary" size="mini" @click="openModel('qtxm', scope.row)">编辑</el-button>
						<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
		<el-dialog title="类别详情" :visible.sync="createModel" top="10vh">
			<!-- 表单内容 -->
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<el-form v-if="preUrl === 'qtxm'" ref="form" :model="form.qtxm" label-width="80px" style="width: 50%;">
					<el-form-item label="项目名称"><el-input v-model="form.qtxm.mc" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="负责人">
						<el-select v-model="form.qtxm.fzr" clearable placeholder="请选择">
							<el-option v-for="item in fzrlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="项目期限">
						<el-date-picker v-model="form.qtxm.xmqx" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
					</el-form-item>
				</el-form>
				<el-form v-if="preUrl === 'qtxm'" ref="form" :model="form.qtxm" label-width="80px" style="width: 50%;">
					<el-form-item label="备注"><el-input v-model="form.qtxm.desc" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="部门">
						<el-select v-model="form.qtxm.bm" clearable placeholder="请选择">
							<el-option v-for="item in bmlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			form: {
				qtxm: {}
			},
			createModel: false,
			dialogType: 'qtxm',
			preUrl: 'qtxm', //api
			dialogId: 0,
			qtxmList: [],
			fzrlist:[],
			bmlist:[]
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	created() {
		this.axios.get('/admin/managers/list', { token: true }).then(res => {
			this.fzrlist = res.data.data;
		});
		this.axios.get('/admin/bumens/list', { token: true }).then(res => {
			this.bmlist = res.data.data;
		});
	},
	methods: {
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`;
		},
		// 处理列表结果
		getListResult(e) {
			this.qtxmList = e.list;
			console.log(this.qtxmList);
		},
		openModel(type, item = false) {
			// 初始化表单
			switch (type) {
				// 初始化添加管理员
				case 'qtxm':
					if (!item) {
						this.form.qtxm = {
							id: '',
							mc: '',
							fzr: '',
							bm: '',
							desc: '',
							xmqx: ''
						};
						this.dialogId = 0;
					} else {
						this.form.qtxm = {
							mc: item.mc,
							desc: item.desc,
							fzr: item.fzr,
							bm: item.bm,
							xmqx: item.xmqx
						};
						this.dialogId = item.id;
					}
					break;
			}
			// 打开dialog
			this.createModel = true;
		},
		submit() {
			let f = this.form.qtxm;
			let e = {
				mc: f.mc,
				desc: f.desc,
				fzr: f.fzr,
				bm: f.bm,
				xmqx: f.xmqx,
				cjr: this.user.id
			};
			console.log(e)
			// this.addOrEdit(e, this.dialogId);
			// this.createModel = false;
		},
		handleCurrentChange(val) {
			this.currentRow = val;
		}
	}
};
</script>

<style></style>
